/**
 * Upload presets — named bundles of {tags, metadata} (author/source/license/…)
 * a user applies to a folder in one click. Asset packs from the same author
 * share these, so saving once and re-applying is the biggest time-saver.
 *
 * Stored in localStorage, namespaced per workspace. All access is defensive —
 * a corrupt/blocked store degrades to "no presets" rather than throwing.
 */

const keyFor = (workspaceId) => `qdex.importPresets.${workspaceId || "default"}`;

export function listPresets(workspaceId) {
    try {
        const raw = localStorage.getItem(keyFor(workspaceId));
        const arr = raw ? JSON.parse(raw) : [];
        return Array.isArray(arr) ? arr : [];
    } catch {
        return [];
    }
}

/** Upsert a preset by name (case-sensitive). Returns the new list. */
export function savePreset(workspaceId, name, payload) {
    const clean = String(name || "").trim();
    if (!clean) return listPresets(workspaceId);
    const preset = {
        name: clean,
        tags: Array.isArray(payload?.tags) ? payload.tags : [],
        metadata: payload?.metadata && typeof payload.metadata === "object" ? payload.metadata : {},
    };
    const next = listPresets(workspaceId)
        .filter((p) => p.name !== clean)
        .concat(preset)
        .sort((a, b) => a.name.localeCompare(b.name));
    try {
        localStorage.setItem(keyFor(workspaceId), JSON.stringify(next));
    } catch {
        /* storage full / blocked — preset just won't persist */
    }
    return next;
}

export function deletePreset(workspaceId, name) {
    const next = listPresets(workspaceId).filter((p) => p.name !== name);
    try {
        localStorage.setItem(keyFor(workspaceId), JSON.stringify(next));
    } catch {
        /* ignore */
    }
    return next;
}
